import { Injectable } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, EventMessage, EventType } from '@azure/msal-browser';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UserRoleService {
    private accountInfo: AccountInfo | null;
    private rolesSubject = new BehaviorSubject<string[]>([]);
    public roles$ = this.rolesSubject.asObservable();

    constructor(private _msalService: MsalService, private msalBroadcastService: MsalBroadcastService) {
        this.accountInfo = _msalService.instance.getActiveAccount();
        if (!this.accountInfo && _msalService.instance.getAllAccounts().length > 0) {
            const accounts = _msalService.instance.getAllAccounts();
            _msalService.instance.setActiveAccount(accounts[0]);
            this.accountInfo = _msalService.instance.getActiveAccount();
        }

        this.msalBroadcastService.msalSubject$
            .pipe(
                filter((msg: EventMessage) =>
                    msg.eventType === EventType.LOGIN_SUCCESS ||
                    msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
                    msg.eventType === EventType.HANDLE_REDIRECT_END
                )
            )
            .subscribe(() => {
                const active = this._msalService.instance.getActiveAccount();
                if (!active && this._msalService.instance.getAllAccounts().length > 0) {
                    const accounts = this._msalService.instance.getAllAccounts();
                    this._msalService.instance.setActiveAccount(accounts[0]);
                    this.accountInfo = this._msalService.instance.getActiveAccount();
                } else {
                    this.accountInfo = active;
                }
            });
    }

    public GetUserRole(): string[] {
        return this.accountInfo?.idTokenClaims?.roles ?? [];
    }

    public HasUserRole(roles: string | string[]): boolean {
        // For AlpConnex.Management, all authenticated users have access
        return this.accountInfo !== null;
    }

    public GetUserID(): string {
        return this.accountInfo?.localAccountId ?? '';
    }

    public GetUserName(): string {
        return this.accountInfo?.name ?? '';
    }

    public GetUserEmail(): string {
        return this.accountInfo?.username ?? '';
    }
}
